<template>
  <editable-base
    ref="base"
    :mode="mode"
    :label="label"
    :error-message="errorMessage"
    :readonly="readonly"
    :show-buttons="showButtons"
    :showErrorMessage="showErrorMessage"
  >
    <b-form-select
      v-if="mode === modes.edit"
      @click="handleMaybeEditClick"
      :class="[
        'est-input',
        mode === modes.processing ? 'text-secondary' : '',
        readonly ? 'readonly' : ''
      ]"
      :id="id"
      v-model="editValue"
      :options="options"
      :disabled="mode !== modes.edit"
      :readonly="readonly"
    />
    <template v-if="editValue && mode === modes.default">
      <b-form-input
        @click="handleMaybeEditClick"
        v-model="inputText"
        :plaintext="true"
      />
    </template>
    <template v-if="!editValue && mode === modes.default">
      <p @click="handleMaybeEditClick" class="text-muted small font-italic">
        no value set {{ readonly ? "" : "&mdash; click to select" }}
      </p>
    </template>
  </editable-base>
</template>

<script>
import { BFormSelect } from "bootstrap-vue";
import EditableBase, { Mixin } from "./EditableBase";
import { BFormInput } from "bootstrap-vue";

export default {
  name: "EditableSelect",
  mixins: [Mixin],
  props: {
    options: Array,
    initialValue: String
  },
  methods: {
    getInputText() {
      let matchValue =
        "undefined" === typeof this.editValue
          ? this.initialValue
          : this.editValue;
      return this.options.find(x => x.value === matchValue)?.text;
    }
  },
  watch: {
    value() {
      this.inputText = this.getInputText();
    }
  },
  data() {
    return {
      inputText: this.getInputText()
    };
  },
  components: {
    BFormSelect,
    EditableBase,
    BFormInput
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss"></style>
